import styled from 'styled-components';
import tw from 'twin.macro';

export const SuccessMessageContainer = styled.div`
  ${tw`flex flex-col items-center self-center w-full`}
`;

export const SuccessDescription = styled.div`
  ${tw`text-base font-inter leading-6 mb-6 font-medium`};
  color: var(--light-blue-gray-500, #64748b);

  @media (max-width: 768px) {
    ${tw`text-sm leading-5`}
    margin-bottom: 16px;
  }
`;

export const IconContainer = styled.div`
  ${tw`flex justify-center items-center`}
`;

export const LineBreak = styled.div`
  ${tw`h-1px w-full my-4 mx-0`};
  background: #cbd5e1;
`;

export const SuccessHeading = styled.p`
  ${tw`text-2xl leading-8 font-semibold mb-4 mt-4 font-inter`};
  color: #334155;
  @media (max-width: 768px) {
    ${tw`text-lg leading-7 mt-6`}
  }
`;
